import React from 'react'
import { EnvironmentOutlined, RightOutlined, EyeOutlined } from '@ant-design/icons'
import '../styles/alarm_card.scss'

// One alert as a tappable card (mobile replacement for a wide table row).
// `alert` is the detection object: { serial_number, vehicle_name, detection_date,
// trigger_type, trigger_level, location:{latitude,longitude}, app_version }.
// `selected` = the alert whose popup was last opened (strong highlight so you keep your
// place after closing it); `viewed` = opened earlier this session (subtle "Viewed" mark).
export const AlarmCard = ({ alert, typeDict, levelDict, onClick, selected, viewed }) => {
  const level = alert?.trigger_level
  const lat = alert?.location?.latitude
  const lng = alert?.location?.longitude
  // detection_date is a naive UTC string; pin +00:00 so it renders in local time.
  const when = alert?.detection_date
    ? new Date(`${alert.detection_date}+00:00`).toLocaleString()
    : '—'

  const cls = ['rz-alarm-card', `lvl-${level}`]
  if (selected) cls.push('rz-selected')
  else if (viewed) cls.push('rz-viewed')

  return (
    <button className={cls.join(' ')} onClick={onClick} aria-current={selected ? 'true' : undefined}>
      <div className="rz-alarm-main">
        <div className="rz-alarm-row1">
          <span className="rz-alarm-unit">{alert?.vehicle_name || alert?.serial_number}</span>
          <span className="rz-alarm-tags">
            {viewed && !selected && (
              <span className="rz-alarm-viewed"><EyeOutlined /> Viewed</span>
            )}
            <span className={`rz-alarm-level lvl-${level}`}>{levelDict?.[level] ?? '—'}</span>
          </span>
        </div>
        <div className="rz-alarm-type">{typeDict?.[alert?.trigger_type] ?? alert?.trigger_type}</div>
        <div className="rz-alarm-meta">
          <span className="rz-alarm-when">{when}</span>
          {(lat != null && lng != null) && (
            <span className="rz-alarm-gps">
              <EnvironmentOutlined /> {Number(lat).toFixed(4)}, {Number(lng).toFixed(4)}
            </span>
          )}
        </div>
      </div>
      <RightOutlined className="rz-alarm-chev" />
    </button>
  )
}

export default AlarmCard
